import React, { useState } from "react";
import { TouchableOpacity, Text } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import GlobalStyles from "../../Resources/Styles";
import Colors from "../../Resources/Color";
import Fonts from "../../Resources/Fonts";
import { useTranslation } from "react-i18next";
import { useDevice } from "../_layout";

const BackButton = ({ action, backString = "back-string" }) => {
  const { t } = useTranslation();
  const { isMobile } = useDevice();
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    if (!isMobile) {
      setIsHovered(true);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      setIsHovered(false);
    }
  };

  const color = isHovered ? Colors.darkBubbleColor : Colors.bubbleColor;

  return (
    <TouchableOpacity
      onPress={action}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        flexDirection: "row",
        alignItems: "center",
        alignSelf: "flex-start",
        paddingRight: 4,
      }}
    >
      <Ionicons name="chevron-back" size={20} color={color} />
      <Text style={[Fonts.medium14, { color }]}>
        {t(backString)}
      </Text>
    </TouchableOpacity>
  );
};

export default BackButton;
